module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calView"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('full-calendar', {
    attrs: {
      "events": _vm.events,
      "config": _vm.config
    },
    on: {
      "event-selected": _vm.eventSelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "eventsModel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.eventDetails[0].TrainingName) + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.eventDetails), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("fdate")(item.Date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Topic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Presenter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("ftime")(item.StartTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("ftime")(item.EndTime)))])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Topic")]), _vm._v(" "), _c('th', [_vm._v("Presenter")]), _vm._v(" "), _c('th', [_vm._v("Start Time")]), _vm._v(" "), _c('th', [_vm._v("End Time")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-546c674d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrainingCalender/calender.vue
// module id = 813
// module chunks = 1